import { useState } from 'react';
import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import UpcomingSessions from './UpcomingSessions';

const UpcomingSessionsPage = () => {
  const [title, setTitle] = useState('Sessions - Upcoming');

  return (
    <Page
      sectionName="sessions"
      breadcrumbs={['upcomingSessions']}
      pageId={Pages.UPCOMING_SESSIONS}
      navPhoto={{ image: '/images/activities/left_sidebar.jpg' }}
      title={title}
      requireAuth
      disablePageLoader={true}
    >
      <UpcomingSessions setTitle={setTitle} />
    </Page>
  )
};

export default UpcomingSessionsPage;
